module.exports = __webpack_public_path__ + "img/creat_tips.eb0aebe9.png";